import { Button, Result, Skeleton, Space, Typography } from 'antd';
import { ActivationBlockReason } from '@/core/domain/enterprise/Companies/Activation/Activation.types';
import { getActivationBlockMessage } from '@/core/domain/enterprise/Companies/Activation/Activation.utils';
import { useActivationHashPage } from '../../ActivationHashPage.context';

export default function ActivationResult() {
  const { blockReason, isTokenLoading, refetchToken } = useActivationHashPage();

  if (isTokenLoading) {
    return (
      <Space
        className="activation-hash-page__loading"
        direction="vertical"
        size={18}
      >
        <Typography.Title level={3}>
          Validando link de ativação
        </Typography.Title>
        <Typography.Paragraph type="secondary">
          Aguarde enquanto confirmamos se este link ainda está disponível.
        </Typography.Paragraph>
        <Skeleton active paragraph={{ rows: 4 }} title={false} />
      </Space>
    );
  }

  if (!blockReason) return null;

  const isUnexpected = blockReason === ActivationBlockReason.Unexpected;

  return (
    <Result
      status={isUnexpected ? 'error' : 'warning'}
      title="Ativação da oficina"
      subTitle={getActivationBlockMessage(blockReason)}
      extra={
        isUnexpected ? (
          <Button type="primary" size="middle" onClick={refetchToken}>
            Tentar novamente
          </Button>
        ) : undefined
      }
    />
  );
}
